"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconButtonStyles = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var style_1 = require("../../../style");
var containedBaseStyles = function (backgroundHover, color, backgroundColor) {
    if (color === void 0) { color = 'white'; }
    if (backgroundColor === void 0) { backgroundColor = 'none'; }
    return ({
        color: color,
        backgroundColor: backgroundColor,
        borderRadius: 4,
        '&:hover': {
            backgroundColor: backgroundHover,
        },
    });
};
exports.useIconButtonStyles = core_1.makeStyles(function () { return ({
    extraSmall: {
        width: 24,
        height: 24,
        fontSize: 16,
    },
    small: {
        width: 32,
        height: 32,
        fontSize: 20,
    },
    medium: {
        width: 40,
        height: 40,
        fontSize: 24,
    },
    containedPrimary: tslib_1.__assign({}, containedBaseStyles(style_1.darkGreen, 'white', style_1.mediumGreen)),
    containedSecondary: tslib_1.__assign({}, containedBaseStyles(style_1.darkMediumBlue, 'white', style_1.darkBlue)),
    containedTertiary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, 'white', style_1.mediumLightBlue)),
    textPrimary: tslib_1.__assign({}, containedBaseStyles(style_1.darkGreen, style_1.mediumGreen)),
    textSecondary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, style_1.darkBlue)),
    textTertiary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, style_1.mediumLightBlue)),
    disabledContainedPrimary: {
        opacity: 0.4,
        backgroundColor: style_1.mediumGreen + " !important",
        color: style_1.white + ' !important',
    },
    disabledContainedSecondary: {
        opacity: 0.4,
        backgroundColor: style_1.darkBlue + " !important",
        color: style_1.white + ' !important',
    },
    disabledContainedTertiary: {
        opacity: 0.4,
        backgroundColor: style_1.mediumLightBlue + " !important",
        color: style_1.white + ' !important',
    },
}); });
